module.exports = __webpack_public_path__ + "images/dingtalk-guide-23617b635efacf382e0796d98d7bd76a.png";